import FinalDisposition from '@/common/containers/Modals/FinalDisposition/FinalDisposition';

export default FinalDisposition;
